import { Icon, SkeletonBodyText, SkeletonDisplayText, SkeletonThumbnail, BlockStack, InlineStack, Layout, Card, SkeletonTabs, Divider, Grid } from '@shopify/polaris';
import { ChevronRightMinor } from '@shopify/polaris-icons';
import { Table } from 'antd';
import React from 'react';
import "./skeleton.css";

export const rows: any = Array.from({ length: 9 }).map((_, ind) => ({
    key: ind + 1,
    image: <SkeletonThumbnail size="medium" />,
    title: <SkeletonBodyText lines={2} />,
    sku: <SkeletonBodyText lines={2} />,
    productDetails: <SkeletonBodyText lines={4} />,
    template: <SkeletonBodyText lines={1} />,
    quantity: <SkeletonBodyText lines={1} />,
    variants: <SkeletonBodyText lines={1} />,
    status: <div className='Custom__Status--Skeleton'><SkeletonDisplayText size="small" /></div>,
    activity: <div className='Custom__Activity--Skeleton'>
        <BlockStack gap="100" inlineAlign='center'>
            <div><SkeletonDisplayText size="small" /></div>
            <div><SkeletonBodyText lines={1} /></div>
        </BlockStack>
    </div>,
    feed: <div className='Custom__Feed--Skeleton'><SkeletonThumbnail size="extraSmall" /></div>,
    action: <div className='Custom__ActionGrid--Skeleton'>
        <InlineStack gap="200" align='center'>
            <SkeletonDisplayText size="small" />
            <SkeletonThumbnail size="small" />
        </InlineStack>
    </div>,
}))

const TableSkeleton = () => {
    const columns: any = [
        {
            title: 'Image',
            dataIndex: 'image',
            align: 'left',
            width: '90px',
        },
        {
            title: ' Title',
            dataIndex: 'title',
            align: 'left',
            width: '180px',
        },
        {
            title: ' Product Details',
            dataIndex: 'productDetails',
            align: 'left',
            width: '200px',
        },
        {
            title: 'Template',
            dataIndex: 'template',
            align: 'left',
            width: '100px',
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            align: 'left',
            width: '250px',
        },
        {
            title: 'Inventory',
            dataIndex: 'quantity',
            align: 'left',
            width: ' 180px',
        },
        {
            title: 'Variants',
            dataIndex: 'variants',
            align: 'left',
            width: ' 88px',
        },
        {
            title: 'Amazon Status',
            dataIndex: 'status',
            align: 'center',
            width: '150px',
        },
        {
            title: 'Activity',
            dataIndex: 'activity',
            align: 'center',
            width: '180px',
        },
        {
            title: 'Feed',
            dataIndex: 'feed',
            align: 'center',
            width: '70px',
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            align: 'left',
            width: '90px',
        },
    ];

    return <div>
        <Table columns={columns} dataSource={rows} expandable={{
            expandedRowRender: (

            ) => (<div></div>),
            rowExpandable: () => true,
            expandIcon: () => {

                return <span style={{
                    cursor: 'pointer'
                }}>
                    <div>
                        <Icon
                            source={ChevronRightMinor}
                            tone="base"
                        />
                    </div>
                </span>

            }
        }} rowSelection={{ selectedRowKeys: [] }} pagination={false} size="middle" scroll={{ x: 700 }} sticky />
    </div>;
}



export default TableSkeleton;

export const modalLoader = () => {
    return (
        // <Layout>
        //     <Layout.Section variant='oneThird'>
        //         <Card>
        //             <SkeletonDisplayText size='extraLarge' />
        //             <SkeletonDisplayText size='extraLarge' />
        //             <SkeletonDisplayText size='extraLarge' />
        //             <SkeletonDisplayText size='extraLarge' />
        //             <SkeletonDisplayText size='extraLarge' />
        //             <SkeletonDisplayText size='extraLarge' />
        //         </Card>
        //     </Layout.Section>
        //     <Layout.Section>
        //         <SkeletonDisplayText size='extraLarge' />
        //         <SkeletonDisplayText size='extraLarge' />
        //         <Card>
        //             <InlineStack gap='400'>
        //                 <SkeletonDisplayText size='extraLarge' />
        //                 <SkeletonDisplayText size='extraLarge' />
        //             </InlineStack>
        //             <SkeletonBodyText />
        //             <SkeletonBodyText />
        //         </Card>

        //     </Layout.Section>
        // </Layout>
        <div className='custom_tabs'>
            <BlockStack gap="500">
                <BlockStack gap="100">
                    <SkeletonTabs />
                    <Divider />
                </BlockStack>
                <div className='Custom__Banner--Skeleton'>
                    <SkeletonDisplayText size="medium" />
                </div>
                <Grid columns={{ xs: 1, sm: 1, md: 5, lg: 5, xl: 5 }}>
                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}>
                        <div className='Custom__GridImage--Skeleton'>
                            <BlockStack inlineAlign='center'>
                                <SkeletonThumbnail size="large" />
                            </BlockStack>
                        </div>
                    </Grid.Cell>
                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }}>
                        <BlockStack gap="500">
                            <SkeletonDisplayText size="small" />
                            <BlockStack gap="300">
                                <SkeletonBodyText lines={2} />
                                <Divider />
                                <SkeletonBodyText lines={4} />
                                <Divider />
                                <SkeletonBodyText lines={2} />
                                <Divider />
                                <SkeletonBodyText lines={4} />
                            </BlockStack>
                        </BlockStack>
                    </Grid.Cell>
                </Grid>
            </BlockStack>
        </div>
    )
}